<div class="min-h-screen bg-slate-50 flex justify-center sm:pb-20">
  <div
    class="w-full max-w-md bg-white min-h-screen sm:min-h-[calc(100vh-2rem)] sm:mt-8 sm:rounded-3xl sm:shadow-2xl sm:border border-slate-200 overflow-hidden relative flex flex-col">

    <!-- Hero Section -->
    <div
      class="bg-gradient-to-br from-blue-600 to-indigo-600 px-5 pt-14 pb-20 flex flex-col items-center text-center relative overflow-hidden">
      <!-- Glow effect -->
      <div
        class="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-white/20 via-transparent to-transparent">
      </div>

      <!-- Animated Check Icon -->
      <div
        class="relative z-10 w-24 h-24 rounded-full bg-white/20 flex items-center justify-center mb-5 ring-8 ring-white/10 shadow-lg shadow-blue-900/10">
        <!-- พื้นขาวทุกโหมด เพื่อให้ไอคอนเป็นสีหลักที่ตั้งค่าไว้ตรงๆ -->
        <div class="w-20 h-20 rounded-full bg-[#fff] flex items-center justify-center shadow-inner">
          <span class="material-symbols-outlined text-[var(--theme-primary,#2563eb)]" style="font-size:48px">check_circle</span>
        </div>
      </div>

      <div class="relative z-10 text-2xl font-black text-white tracking-tight drop-shadow-sm">{{ 'อัปโหลดหลักฐานสำเร็จ!' | translate : 'booking-success' }}
      </div>
      <div class="relative z-10 mt-3 text-[13px] font-medium text-white/90 leading-relaxed max-w-xs">
        {{ 'เรากำลังตรวจสอบหลักฐานการโอนมัดจำ' | translate : 'booking-success' }}<br>
        {{ 'รอการยืนยันที่อีเมล' | translate : 'booking-success' }}
        <div class="font-bold text-white mt-1 px-3 py-1.5 bg-black/10 rounded-lg inline-block break-all">{{
          contactEmail() || '-' }}</div>
      </div>
    </div>

    <!-- Content pulled up over hero -->
    <div class="flex-1 w-full px-5 -mt-10 pb-10 space-y-4 relative z-20">

      <!-- Booking Reference -->
      @if (bookingResult()?.bookingNo || bookingResult()?.bookingNumber || bookingResult()?.id) {
      <div class="bg-white rounded-3xl border border-slate-100 shadow-[0_8px_30px_rgba(0,0,0,0.06)] overflow-hidden">
        <div class="px-5 pt-5 pb-5 flex flex-col items-center text-center">
          <div class="flex items-center gap-2 mb-2">
            <div class="w-8 h-8 rounded-xl bg-blue-50 flex items-center justify-center border border-blue-100">
              <span class="material-symbols-outlined text-blue-600 text-[18px]">confirmation_number</span>
            </div>
            <div class="text-[13px] font-bold text-slate-500 uppercase tracking-widest">{{ 'หมายเลขการจอง' | translate : 'booking-success' }}</div>
          </div>
          <div class="text-3xl font-black text-slate-800 tracking-wider">
            {{ bookingResult()?.bookingNo ?? bookingResult()?.bookingNumber ?? bookingResult()?.id }}
          </div>
        </div>
      </div>
      }

      <!-- Booking Detail Card -->
      @if (bookingData()) {
      <div class="bg-white rounded-3xl border border-slate-100 shadow-sm overflow-hidden mt-6">

        <!-- Hotel -->
        <div class="p-5 relative overflow-hidden">
          <div class="absolute right-0 top-0 w-32 h-32 bg-blue-50 rounded-full blur-3xl -z-10 opacity-60"></div>
          <div class="flex items-center gap-3 mb-4">
            <div class="w-8 h-8 rounded-xl bg-blue-50 flex items-center justify-center shrink-0 border border-blue-100">
              <span class="material-symbols-outlined text-blue-500 text-[18px]">hotel</span>
            </div>
            <div class="text-[15px] font-bold text-slate-800 leading-tight">{{ bookingData().branchName }}</div>
          </div>
          @if (bookingData().branchAddress) {
          <div class="flex items-start gap-1.5 mt-2 bg-slate-50 p-3 rounded-2xl border border-slate-100">
            <span class="material-symbols-outlined text-[16px] text-slate-400 mt-0.5 shrink-0">location_on</span>
            <div class="text-[13px] font-medium text-slate-500 leading-relaxed">{{ bookingData().branchAddress }}</div>
          </div>
          }
        </div>

        <!-- Dates -->
        <div class="grid grid-cols-2 border-t border-slate-50">
          <div class="p-5">
            <div class="flex items-center gap-2 mb-2">
              <span class="material-symbols-outlined text-[16px] text-blue-600">login</span>
              <span class="text-[11px] font-bold text-slate-400 uppercase tracking-wider">{{ 'เช็คอิน' | translate : 'booking-success' }}</span>
            </div>
            <div class="text-[15px] font-bold text-slate-800">
              {{ bookingData().checkIn | thaidate:'long' }}
            </div>
          </div>
          <div class="p-5 border-l border-slate-50">
            <div class="flex items-center gap-2 mb-2">
              <span class="material-symbols-outlined text-[16px] text-red-500">logout</span>
              <span class="text-[11px] font-bold text-slate-400 uppercase tracking-wider">{{ 'เช็คเอาต์' | translate : 'booking-success' }}</span>
            </div>
            <div class="text-[15px] font-bold text-slate-800">
              {{ bookingData().checkOut | thaidate:'long' }}
            </div>
          </div>
        </div>

        <!-- Stay summary -->
        <div class="px-5 pb-4 border-t border-slate-50">
          <div class="mt-4 flex items-center gap-5 flex-wrap">
            <div class="flex items-center gap-2 bg-slate-50 px-3 py-1.5 rounded-xl border border-slate-100">
              <span class="material-symbols-outlined text-[16px] text-slate-400">nights_stay</span>
              <span class="text-[13px] text-slate-700 font-bold">{{ bookingData().totalNights }} <span
                  class="text-slate-500 font-medium">{{ 'คืน' | translate : 'booking-success' }}</span></span>
            </div>
            <div class="flex items-center gap-2 bg-slate-50 px-3 py-1.5 rounded-xl border border-slate-100">
              <span class="material-symbols-outlined text-[16px] text-slate-400">door_open</span>
              <span class="text-[13px] text-slate-700 font-bold">{{ bookingData().totalRooms }} <span
                  class="text-slate-500 font-medium">{{ 'ห้อง' | translate : 'booking-success' }}</span></span>
            </div>
            <div class="flex items-center gap-2 bg-slate-50 px-3 py-1.5 rounded-xl border border-slate-100">
              <span class="material-symbols-outlined text-[16px] text-slate-400">person</span>
              <span class="text-[13px] text-slate-700 font-bold">
                {{ 'ผู้ใหญ่' | translate : 'booking-success' }} {{ bookingData().totalAdults }} <span class="text-slate-500 font-medium">{{ 'ท่าน' | translate : 'booking-success' }}</span>
                @if (bookingData().totalChildren > 0) { <span class="text-slate-400 mx-1">·</span> {{ 'เด็ก' | translate : 'booking-success' }} {{
                bookingData().totalChildren }} <span class="text-slate-500 font-medium">{{ 'คน' | translate : 'booking-success' }}</span> }
              </span>
            </div>
          </div>
          <div class="mt-4 space-y-2">
            @for (r of bookingData().selectedRooms; track $index) {
            <div class="flex items-start gap-2.5">
              <div class="mt-1.5 w-1.5 h-1.5 rounded-full bg-blue-400 shrink-0"></div>
              <div>
                <div class="text-[13px] font-bold text-slate-700">{{r.qty}}x {{r.roomName}}</div>
                <div class="text-[11px] font-medium text-slate-400">{{r.planName}}</div>
              </div>
            </div>
            }
          </div>
        </div>

        <!-- Total -->
        <div class="px-5 py-4 border-t border-slate-50 flex items-center justify-between bg-blue-50/30">
          <div class="text-[11px] font-bold text-slate-500 uppercase tracking-wider">{{ 'ยอดชำระตรวจสอบ' | translate : 'booking-success' }}</div>
          <div class="text-xl font-black text-blue-600 tracking-tight">{{ bookingData().totalPrice | number }} <span
              class="text-[13px] font-semibold text-slate-400">THB</span></div>
        </div>
      </div>
      }

      <!-- Notice -->
      <div class="rounded-3xl bg-amber-50 border border-amber-100 px-5 py-4 mt-6">
        <div class="flex items-start gap-3">
          <span class="material-symbols-outlined text-amber-500 text-[20px] shrink-0 mt-0.5">info</span>
          <div class="text-[13px] font-medium leading-relaxed text-amber-800">
            {{ 'กรุณาตรวจสอบอีเมลของท่านเพื่อรับรายละเอียดการจอง' | translate : 'booking-success' }}<br>
            {{ 'หากไม่พบในกล่องจดหมายเข้า กรุณาตรวจสอบในโฟลเดอร์จดหมายขยะ' | translate : 'booking-success' }}
          </div>
        </div>
      </div>

      <!-- Home Button -->
      <button
        class="mt-6 w-full rounded-2xl bg-slate-900 py-4 text-[15px] font-bold text-white hover:bg-black active:scale-[0.98] transition-all flex items-center justify-center gap-2 shadow-lg shadow-black/10"
        (click)="goHome()">
        <span class="material-symbols-outlined text-[20px]">home</span>
        {{ 'กลับสู่หน้าหลัก' | translate : 'booking-success' }}
      </button>

    </div>
  </div>
</div>